import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.css']
})
export class InputSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() id: string = '';
  @Input() title: string = '';
  @Input() enabledDefaultOption: boolean = false;
  @Input() dataSelect: Array<any | { value: any, label: any }> = [];

  @Input() placeholder: string = 'Selecciona una opción';

  constructor() { }
}
